import AdmService from '../../services/AdmService'

const state = () => ({
    loadingAdm: false,
    current_adm: null,
    new_adm: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        status: 'pendente'
    },
    admins: [],
    total: 0,
    pages: 0,
    page: 1,
    show_modal_filter_adm: false,
    filters_adm: [
        {
            id: 'status',
            name: 'Status',
            type: 'select',
            isOpen: false,
            options: [
                { value: 'ativo', label: 'Ativo', checked: false },
                { value: 'inativo', label: 'Inativo', checked: false },
                { value: 'pendente', label: 'Pendente', checked: false },
                { value: 'banida', label: 'Banida', checked: false }
            ],
        },
        {
            id: 'permission',
            name: 'Permissões',
            type: 'select',
            isOpen: false,
            options: [
                { value: 'ai.create', label: 'IA - Criar', checked: false },
                { value: 'ai.read', label: 'IA - Ler', checked: false },
                { value: 'ai.update', label: 'IA - Atualizar', checked: false },
                { value: 'ai.delete', label: 'IA - Deletar', checked: false },
                { value: 'users.manage', label: 'Gerenciar Usuários', checked: false },
                { value: 'admins.manage', label: 'Gerenciar Admins', checked: false }
            ],
        }
    ],
})

const mutations = {
    SET_CURRENT_ADM: (state, payload) => {
        state.current_adm = payload
    },
    RESET_NEW_ADM: (state) => {
        state.new_adm = { firstName: '', lastName: '', email: '', password: '', status: 'pendente' }
    },
    SET_ADMINS: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.admins = payload.itens
        } else {
            state.admins = [...state.admins, ...payload.itens]
        }
        state.page = payload.pageNumber
        state.pages = payload.pages
        state.total = payload.total
    },
    SET_LOADING_ADM: (state, payload) => {
        state.loadingAdm = payload
    },
    SET_SHOW_MODAL_FILTER_ADM: (state, boolean) => {
        state.show_modal_filter_adm = boolean
    },
    TOGGLE_FILTER_ADM_OPTION(state, { filterId, optionValue }) {
        const filter = state.filters_adm.find(f => f.id === filterId);
        if (filter) {
            const option = filter.options.find(o => o.value === optionValue);
            if (option) {
                option.checked = !option.checked;
            }
        }
    },
}

const actions = {
    async fetchAdmin({commit}, id){
        try{
            commit('SET_LOADING_ADM', true)
            const response = await AdmService.getOne(id);
            commit('SET_CURRENT_ADM', response.data.item)
            commit('SET_LOADING_ADM', false)
            return response.data.item
        } catch (error) {
            commit('SET_LOADING_ADM', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao carregar o Admin'
            });
        }
    },
    async fetchAdmins({commit, state}, { keyword = '', pageNumber = 1, order = { name: 'ID', column: 'id', sort: 'DESC' } }) {
        try{
            commit('SET_LOADING_ADM', true)
            let filters = state.filters_adm.reduce((acc, filter) => {
                acc[filter.id] = filter.options.filter(option => option.checked).map(option => option.value);
                return acc;
            }, {});
            const response = await AdmService.get(keyword, pageNumber, filters, order);
            commit('SET_ADMINS', response.data)
            commit('SET_LOADING_ADM', false)
        } catch (error) {
            commit('SET_LOADING_ADM', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createAdmin({commit}, data){
        try{
            commit('SET_LOADING_ADM', true)
            const response = await AdmService.create(data);
            commit('RESET_NEW_ADM')
            commit('SET_ALERT', { heading: 'success', message: response.data.message });
            commit('SET_LOADING_ADM', false)
            return response.data.item
        } catch (error) {
            commit('SET_LOADING_ADM', false);
            commit('SET_ALERT', { heading: 'error', message: error.response?.data?.message || 'Falha ao criar Admin' });
        }
    },
    async updateAdmin({commit}, { id, data }){
        try{
            commit('SET_LOADING_ADM', true)
            const response = await AdmService.update(id, data);
            commit('SET_ALERT', { heading: 'success', message: response.data.message || 'Adm Atualizado' });
            commit('SET_LOADING_ADM', false)
        } catch (error) {
            commit('SET_LOADING_ADM', false);
            commit('SET_ALERT', { heading: 'error', message: error.response?.data?.message || 'Falha ao atualizar Admin' });
        }
    },
    async updateAdminPermissions({commit}, { id, permissions }){
        try{
            commit('SET_LOADING_ADM', true)
            const response = await AdmService.updatePermissions(id, { permissions });
            commit('SET_LOADING_ADM', false)
            return response.data
        } catch (error) {
            commit('SET_LOADING_ADM', false);
            throw error
        }
    },
    async exportAdmins({ state }, { keyword = '', order = { name: 'ID', column: 'id', sort: 'DESC' } }) {
        try {
            let filters = state.filters_adm.reduce((acc, filter) => {
                acc[filter.id] = filter.options.filter(option => option.checked).map(option => option.value);
                return acc;
            }, {});

            const response = await AdmService.export(keyword, filters, order);

            const date = new Date().toISOString().slice(0, 10);
            const fileName = `Relatorio_Admins_${date}.csv`;
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Erro ao exportar Admins:', error);
        }
    },
    toggleFilterAdmOption({ commit, dispatch }, payload) {
        commit('TOGGLE_FILTER_ADM_OPTION', payload);
        dispatch('fetchAdmins', {keyword: "", pageNumber: 1})
    },
}

const getters = {
    getCurrentAdm: state => state.current_adm,
    getNewAdm: state => state.new_adm,
    getAdmins: state => state.admins,
    getLoadingAdm: state => state.loadingAdm,
    getShowModalFilterAdm: state => state.show_modal_filter_adm,
    getFiltersAdm: state => state.filters_adm
}

export default {
    state,
    getters,
    mutations,
    actions
};